import { OrganizationType } from '../types';

export enum CardPaymentSystem {
  VISA = 'Visa',
  MASTER_CARD = 'Mastercard',
  UNION_PAY = 'UnionPay',
}

export enum CardType {
  DEBIT = 'debit',
  CORP = 'corp',
}

export enum CardStatus {
  NEW = 'New',
  ORDERED = 'Ordered',
  APPROVED = 'Approved',
  ACTIVE = 'Active',
  FROZEN = 'Frozen',
  CANCELED = 'Canceled',
  VOID = 'Void',
}
export interface CustomerCard {
  id: string;
  paymentSystem: CardPaymentSystem;
  number: string;
  type?: CardType;
  expiredDate: string;
  balance?: string;
  balanceCurrency: string;
  status: CardStatus;
  customerAccountId: string;
  address: string;
  customerFirstName: string;
  customerLastName: string;
  countryId?: string;
  virtual?: boolean;
  city?: string;
  postCode?: string;
  street?: string;
  apartment?: string;
  availableStatuses?: {
    name: string;
    value: CardStatus;
  }[];
}
export interface CustomerCardsTransactionsTypes {
  customerType: OrganizationType;
  cards?: CustomerCard[];
}

export interface OrderCardFormValues {
  userId: string;
  physical?: boolean;
  cardType?: string;
  paymentSystem: string;
  countryId?: string;
  city?: string;
  postCode?: string;
  street?: string;
  apartment?: string;
  countryName?: string;
}
